import clienteAxios from "../config/axios";

export async function getAllNivel3s() {
    return clienteAxios.get(`/nivel3`);
}

export async function addNivel3(datos) {
    
    const nivel3 = {
        codNivel3: datos.codNivel3,
        nameNivel3: datos.name,
        descrp: datos.descrp,
        nivel3Nivel2ID: datos.nivel2Nivel3._id,
        codNivel2: datos.nivel2Nivel3.codNivel2,
        direccion: datos.direccion || null,
        lat: datos.lat || null,
        lng: datos.lng || null
    }

    return clienteAxios.post(`/nivel3`, nivel3 );
}

export async function updateNivel3(datos) {

    const id = datos.id
    const updates = {
        id: datos.id,
        codNivel3: datos.codNivel3,
        nameNivel3: datos.name,
        descrp: datos.descrp,
        codNivel2:datos.codNivel2,
        nivel3Nivel2ID: datos.nivel3Nivel2ID,
        direccion: datos.direccion || null,
        lat: datos.lat || null,
        lng: datos.lng || null
    }

    return clienteAxios.put(`/nivel3/${id}`,updates);
}

export async function deleteNivel3(id) { return clienteAxios.delete(`/nivel3/${id}`,id); }

export async function deleteNivel3AndChildren(id, deleteActivesToo) {
    return clienteAxios.delete(`/nivel3/deleteLevelAndChildren/${id}?deleteActivesToo=${deleteActivesToo}`,{id});
}


export async function updatePositioning(updates){
    return clienteAxios.post(`/nivel3/updatePositioning`,{updates});
}